<h1 mat-dialog-title>Prepaideinheiten buchen</h1>
<div mat-dialog-content>
  <mat-form-field>
    <mat-label>Einheiten</mat-label>
    <input matInput [(ngModel)]="data.units">
  </mat-form-field>
</div>
<div mat-dialog-actions>
  <button mat-stroked-button (click)="onNoClick()">Abbrechen</button>
  <button mat-stroked-button color="primary" [mat-dialog-close]="data.units" cdkFocusInitial>Buchen</button>
</div>
